import React from "react";

export default (props) => {

    const { children, title } = props;

    var linkProps = {
        ...props,
        className: `tap-area button--icon ${props.className || ''}`
    }
    delete linkProps.children;

    return <a {...linkProps} >
            {title && <span class="sr-only">{title}</span>}
            {children}
        </a>
}
